import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./views/Home.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/user',
    name: 'UserHome',
    component: () => import('./views/UserHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/like_log',
    name: 'LikeLog',
    component: () => import('./views/LikeLog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/likes/:month',
    name: 'LikeLogPage',
    component: () => import('./views/LikeLogPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/likes_followed',
    name: 'OthersLikeFollowlist',
    component: () => import('./views/OthersLikeFollowlist.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/likes_followed_log/:userid',
    name: 'OthersLikeLog',
    component: () => import('./views/OthersLikeLog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/likes_followed_log_page',
    name: 'OthersLikeLogPage',
    component: () => import('./views/OthersLikeLogPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/retweet',
    name: 'UserRT',
    component: () => import('./views/UserRT.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mystock',
    name: 'Mylist',
    component: () => import('./views/Mylist.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/followstock',
    name: 'Followlist',
    component: () => import('./views/Followlist.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/stock/:id',
    name: 'ListPage',
    component: () => import('./views/ListPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/ranking/:day',
    name: 'RankingPage',
    component: () => import('./views/RankingPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/randomranking',
    name: 'RankingPage',
    component: () => import('./views/RandomRankingPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('./views/Help.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('./views/History.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('./views/Test.vue'),
    meta: { requiresAuth: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ログインが完了していない場合にサインインページに飛ばす
router.beforeEach( (to, from, next) => {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if(requiresAuth == false) {
    next()
    return
  }
  if(store.getters.isInit == true){
    if(store.getters.isLogin == true) next()
    else next('/')
    return
  }
  const unwatch = store.watch((state, getters) => getters.isInit, () => {
    unwatch()
    if (store.getters.isLogin==true) next()
    else next('/')    
  })    
})

export default router
